import { render, staticRenderFns } from "./StatisticByGraduationYear.vue?vue&type=template&id=89e2cc82&"
import script from "./StatisticByGraduationYear.vue?vue&type=script&lang=js&"
export * from "./StatisticByGraduationYear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports